import { SpinRequestBuilder } from "ags/integration/builders/requests/spin-request-builder";
import { ForceList } from "slotworks/debug/menu/force-list";
import Contract from "slotworks/utils/contracts/contract";

class AGSForcer implements ForceList {

    private results: Map<string, string> = new Map<string, string>();

    public setResults(results: Map<string, string>) {
        this.results = results;
    }

    public getList(): Contract<string[]> {
        return new Contract<string[]>((resolve) => {
            resolve(Array.from(this.results.keys()));
        });
    }

    public force(id: string): Contract<void> {
        SpinRequestBuilder.force = this.results.has(id) ? this.results.get(id) : id;
        return Contract.empty();
    }
}

export default new AGSForcer();
